import React from 'react';

type SearchResultSkeletonProps = {
    rows?: number;
};

function SkeletonBar({ className = '' }: { className?: string }) {
    return (
        <div className={`animate-pulse rounded bg-gray-200 dark:bg-gray-700 ${className}`} />
    );
}

/** List-shaped loading placeholder matching SearchResult / ChangeListItem rows. */
function SearchResultSkeleton(props: SearchResultSkeletonProps) {
    const rowCount = Math.max(1, props.rows ?? 5);

    return (
        <div
            className="mt-3 space-y-2"
            data-testid="search-result-skeleton"
            aria-busy="true"
            aria-live="polite"
        >
            <SkeletonBar className="mb-3 h-4 w-24" />
            {Array.from({ length: rowCount }).map((_, index) => (
                <div
                    key={index}
                    className="flex min-h-[60px] items-center gap-2 rounded border border-gray-200 p-2 dark:border-gray-700"
                >
                    <div className="flex flex-col gap-1">
                        <SkeletonBar className="h-5 w-[70px]" />
                        <SkeletonBar className="h-5 w-[70px]" />
                    </div>
                    <div className="min-w-0 flex-1 space-y-1.5">
                        <SkeletonBar className="h-4 w-3/4 max-w-md" />
                        <SkeletonBar className="h-3 w-1/3 max-w-[10rem]" />
                        <SkeletonBar className="h-3 w-2/5 max-w-[12rem]" />
                    </div>
                    <SkeletonBar className="h-5 w-8 shrink-0" />
                    <SkeletonBar className="h-6 w-6 shrink-0 rounded-full" />
                </div>
            ))}
        </div>
    );
}

export default SearchResultSkeleton;
